import { render, staticRenderFns } from "./addannounce.vue?vue&type=template&id=5c83fc9e&"
import script from "./addannounce.vue?vue&type=script&lang=js&"
export * from "./addannounce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c83fc9e')) {
      api.createRecord('5c83fc9e', component.options)
    } else {
      api.reload('5c83fc9e', component.options)
    }
    module.hot.accept("./addannounce.vue?vue&type=template&id=5c83fc9e&", function () {
      api.rerender('5c83fc9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addannounce.vue"
export default component.exports